<h1 mat-dialog-title>{{ getLabel('titleLabel') }}</h1>

<div mat-dialog-content>

  <p>
    {{ getLabel('textLabel')}}
  </p>

  <form [formGroup]="form" class="form-container">

    <app-select-search (changeValue)="selectStartWorkflow($event)" class="width100" appearance="fill" formControlName="startWorkflow" [items]="workflows" viewField="label" [label]="getLabelSelect('startWorkflow')">
    </app-select-search>

    <app-select-search class="width100" appearance="fill" formControlName="action" [items]="actions" viewField="name" [label]="getLabelSelect('action')" [noUsers]="actionDisabled()">
    </app-select-search>

    <app-select-search class="width100" appearance="fill" formControlName="endWorkflows" [items]="endWorkflows" viewField="label" [label]="getLabelSelect('endWorkflows')" [multiple]="true" [noUsers]="endWorkflowsDisabled()">
    </app-select-search>


  </form>

</div>

<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="form.value" [disabled]="disabledConfirmButton()">{{ confirmButtonLabel |
    translate }}</button>
  <button mat-button [mat-dialog-close]="">{{ cancelButtonLabel | translate }}</button>
</div>